<template>
    <FormSection title="Service Location" type="his-section" :full-height="false" :application-id="application">
        <template #content>
            <div class="d-flex flex-column px-3 py-2">
                <AddServiceLocationForm
                    v-if="showServiceForm"
                    :service="service"
                    :reset-list="resetList"
                    :showServiceForm="showServiceForm"
                    :closeServiceForm="closeServiceForm"
                    ref="serviceLocationForm"
                />

                <div class="d-flex justify-content-end" v-else>
                    <button class="btn btn-primary ms-2 mb-2" @click="openServiceLocationForm()">
                        Add Service Location
                    </button>
                </div>

                <Pagination ref="serviceLocationList" :page-changed="pageChangedCallback" :isLoading="isLoading">
                    <table class="table table-responsive-md border border-gray">
                        <thead>
                            <tr class="bg-table-header">
                                <th>Service Location <span class="text-danger">*</span></th>
                                <th>Date</th>
                                <th>Time</th>
                                <th class="text-end">Actions</th>
                            </tr>
                        </thead>
                        <tbody v-if="isLoading || isError || !hasData">
                            <!-- LOADING -->
                            <tr v-for="i of loadingCount" class="table-loading" :key="i" v-if="isLoading">
                                <td v-for="i of columns" :key="i">
                                    <span class="shimmer-loading"></span>
                                </td>
                            </tr>
                            <!-- EMPTY -->
                            <tr class="table-empty" v-if="!isLoading && !isError && !hasData">
                                <td :colspan="columns">
                                    <h5>No Service Location Found</h5>
                                </td>
                            </tr>
                            <!-- ERROR -->
                            <tr class="table-error" v-if="!isLoading && isError">
                                <td :colspan="columns">
                                    <ErrorMessageHandler title="Service Location" :try-again="resetList" />
                                </td>
                            </tr>
                        </tbody>
                        <ServiceLocationRow
                            v-else
                            v-for="service of page.items"
                            :key="service.Id"
                            :service="service"
                            :patientDetails="patientDetails"
                            :columns="columns"
                            :reset-list="resetList"
                            :application="application"
                            :accountId="accountId"
                            :patientId="patientId"
                            :itemCount="itemCount"
                        />
                    </table>
                </Pagination>
            </div>
        </template>
    </FormSection>
</template>

<script src="./ServiceLocations.ts"></script>
